/*
 * Chrome fires `beforeinstallprompt` very early - often before React has
 * mounted - so the listener is registered at import time rather than from an
 * effect, otherwise the event is missed and the install button has nothing to
 * show. iOS fires nothing at all; there the UI falls back to instructions.
 */
let deferred = null;
const listeners = new Set();

function notify() {
  listeners.forEach((fn) => fn(Boolean(deferred)));
}

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferred = event;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    notify();
  });
}

export function hasInstallPrompt() {
  return Boolean(deferred);
}

export function onInstallPromptChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export async function showInstallPrompt() {
  if (!deferred) return false;
  const event = deferred;
  deferred = null;
  notify();
  event.prompt();
  const { outcome } = await event.userChoice;
  return outcome === "accepted";
}
